import { ContactsList } from '../contacts/elements/ContactsList'

export const ClientsList = () => <ContactsList isCustomer />
